/* Tasslugn – lägger flera varor i varukorgen på en gång och uppdaterar
   lådan via temats egna CartLinesUpdateEvent (samma väg som köp-knappen). */
import { CartLinesUpdateEvent } from '@shopify/events';

export async function addItems(items, source) {
  const routes = (window.Theme && window.Theme.routes) || {};
  const sections = Array.from(document.querySelectorAll('cart-items-component'))
    .map((c) => c.dataset.sectionId)
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  (source || document).dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      promise: deferred.promise,
    })
  );
  try {
    const res = await fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items.map((i) => ({ id: Number(i.id), quantity: i.quantity })),
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await res.json();
    const cart = await fetch((routes.cart_url || '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    }).then((r) => r.json());
    if (data.status) {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { didError: true, items: cart.items, source: 'tasslugn' },
      });
      throw new Error(data.description || data.message || 'Kunde inte lägga till');
    }
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        itemCount: items.reduce((s, i) => s + i.quantity, 0),
        sections: data.sections,
        source: 'tasslugn',
        didError: false,
      },
    });
    if (!sections.length) {
      window.location.href = routes.cart_url || '/cart';
      return;
    }
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    setTimeout(() => {
      if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
    }, 60);
  } catch (error) {
    deferred.reject(error);
    throw error;
  }
}